/* RESPONSIBLE TEAM: team-ai-insights */

import type { OptimizeSuggestionList } from 'embercom/services/optimize-suggestions-service';
import type AppService from 'embercom/services/app-service';
import moment from 'moment-timezone';

export type OptimizeSuggestionFilterState = {
  suggestionType: ('content-gap' | 'data-gap' | 'action-gap')[];
  date: string | undefined;
  topics: string[];
};

export function applyFilters(
  appService: AppService,
  suggestions: OptimizeSuggestionList,
  filterState: OptimizeSuggestionFilterState,
): OptimizeSuggestionList {
  let filteredSuggestions: OptimizeSuggestionList = suggestions;
  if (filterState.suggestionType.length > 0) {
    filteredSuggestions = filterBySuggestionType(filteredSuggestions, filterState.suggestionType);
  }
  if (filterState.date) {
    filteredSuggestions = filterByRange(appService, filteredSuggestions, filterState.date);
  }
  if (filterState.topics.length > 0) {
    filteredSuggestions = filterByTopics(filteredSuggestions, filterState.topics);
  }
  return filteredSuggestions;
}

function filterBySuggestionType(
  suggestions: OptimizeSuggestionList,
  suggestionType: ('content-gap' | 'data-gap' | 'action-gap' | 'all')[],
): OptimizeSuggestionList {
  return suggestions.filter((suggestion) => suggestionType.includes(suggestion.suggestionType));
}

function filterByRange(
  appService: AppService,
  suggestions: OptimizeSuggestionList,
  date: string,
): OptimizeSuggestionList {
  let startDate = moment.tz(date, appService.app.timezone).startOf('day');
  let endOfDate = moment.tz(date, appService.app.timezone).endOf('day');
  return suggestions.filter((suggestion) => {
    let suggestionDate = moment.tz(suggestion.createdAt, appService.app.timezone);
    return suggestionDate >= startDate && suggestionDate <= endOfDate;
  });
}

function filterByTopics(
  suggestions: OptimizeSuggestionList,
  topics: string[],
): OptimizeSuggestionList {
  return suggestions.filter((suggestion) =>
    suggestion.topicList.some((topic) => topics.includes(topic)),
  );
}
